import React, { useCallback, useRef, useState, Fragment } from "react";
import useLocations from "./useLocations.js";
import { ShellButton, Modal, ContentWithTitle } from "../Shell/index.js";
import { t } from "@bookingcom/lingojs-core";
import { Text, ActionBar } from "@bookingcom/bui-react";
import { AutoComplete } from "../AutoComplete/index.js";
import { TransportAirplaneDepartIcon, TransportAirplaneArriveIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
const LocationsModal = (props) => {
    const { type, segmentIndex, size } = props;
    const { errorMessage, i18n, placeholderText, selectedLocationsText, trackV2, selectedLocations, setLocations, multiSelectVariant, isA11y2904, searchType, canShowFlyAnywhere } = useLocations({ type, segmentIndex });
    const [showModal, setShowModal] = useState(false);
    const inputRef = useRef(null);
    const buttonRef = useRef(null);
    const [initLocations, setInitLocations] = useState(selectedLocations);
    const autoFocusInput = multiSelectVariant !== 2 && multiSelectVariant !== 3;
    const removeFakeInput = () => {
        const existingFakeInput = document.getElementById("searchbox_overlay_fake_input");
        if (existingFakeInput) {
            existingFakeInput.remove();
        }
    };
    const focusFakeInput = () => {
        removeFakeInput();
        const fakeInput = document.createElement("input");
        fakeInput.id = "searchbox_overlay_fake_input";
        fakeInput.setAttribute("type", "text");
        fakeInput.style.position = "absolute";
        fakeInput.style.height = "0";
        fakeInput.style.width = "0";
        fakeInput.style.opacity = "0";
        document.body.prepend(fakeInput);
        fakeInput.focus();
    };
    const closeModal = useCallback(() => {
        setShowModal(false);
        buttonRef.current?.focus();
    }, []);
    const handleOnClick = useCallback((e) => {
        e.stopPropagation();
        setShowModal(true);
        trackV2(type === "from" ? "click_origin" : "click_destination");
        setInitLocations(selectedLocations);
    }, [selectedLocations, trackV2, type]);
    const handleModalOnClose = useCallback(() => {
        if (document.activeElement === inputRef?.current)
            return;
        closeModal();
        setLocations(initLocations);
    }, [closeModal, initLocations, setLocations]);
    const handleOnFinish = useCallback(() => {
        closeModal();
    }, [closeModal]);
    const handleCTAOnClick = useCallback(() => {
        closeModal();
        if (selectedLocations.length === 0) {
            setLocations(initLocations);
        }
    }, [closeModal, selectedLocations.length, setLocations, initLocations]);
    const errorId = `location_input_${type}_${segmentIndex}_error`;
    return (React.createElement(React.Fragment, null,
        React.createElement(ShellButton, { icon: type === "from" ? TransportAirplaneDepartIcon : TransportAirplaneArriveIcon, errorMessage: errorMessage, errorVariant: "inline", tabIndex: 0, ref: buttonRef, "data-ui-name": `input_location_${type}_segment_${segmentIndex}`, "data-ui-error": Boolean(errorMessage), onClick: handleOnClick, size: size, errorId: errorId, halfVerticalPadding: isA11y2904, alignIcon: isA11y2904 ? "center" : undefined, "aria-describedby": isA11y2904 && searchType === "MULTISTOP" ? `a11y_multi_segment_description_${segmentIndex}` : undefined }, isA11y2904 ? (React.createElement(React.Fragment, null,
            React.createElement(ContentWithTitle, { title: type === "from"
                    ? i18n.trans(t("flights_searchbox_leaving_from"))
                    : i18n.trans(t("flights_searchbox_going_to")), content: selectedLocationsText?.map((tx, idx) => (React.createElement(Fragment, { key: tx.code + idx },
                    tx.code ? React.createElement("b", null,
                        tx.code,
                        " ") : null,
                    tx.name,
                    idx < selectedLocationsText.length - 1 ? (React.createElement(Text, { tagName: "span", variant: "body_2" }, " · ")) : null))) }))) : (React.createElement(React.Fragment, null, selectedLocationsText && selectedLocationsText.length > 0 ? (React.createElement(Text, { tagName: "span", variant: "body_2" }, selectedLocationsText.map((tx, idx) => (React.createElement(Fragment, { key: tx.code + idx },
            tx.code ? React.createElement("b", null,
                tx.code,
                " ") : null,
            tx.name,
            idx < selectedLocationsText.length - 1 ? (React.createElement(Text, { tagName: "span", variant: "body_2" }, " · ")) : null))))) : (React.createElement(Text, { tagName: "span", color: "neutral_alt", variant: "body_2" }, placeholderText))))),
        React.createElement(Modal, { active: showModal, onCloseTrigger: handleModalOnClose, arrowNavigation: true, position: "fullScreen", title: isA11y2904
                ? type === "from"
                    ? i18n.trans(t("flights_searchbox_leaving_from"))
                    : i18n.trans(t("flights_searchbox_going_to"))
                : type === "from"
                    ? i18n.trans(t("flights_search_origin_prompt"))
                    : i18n.trans(t("flights_search_destination_prompt")), footer: multiSelectVariant === 1 ? undefined : (React.createElement(ActionBar, { button: {
                    wide: true,
                    text: i18n.trans(t("flights_multi_select_apply")),
                    size: "large",
                    onClick: handleCTAOnClick,
                    attributes: {
                        "data-ui-name": "button_location_action_bar_done"
                    }
                } })), onOpen: () => {
                if (autoFocusInput) {
                    focusFakeInput();
                }
            }, onAfterOpen: () => {
                if (autoFocusInput) {
                    removeFakeInput();
                    inputRef.current?.focus();
                }
            } },
            React.createElement(AutoComplete, { type: type, segmentIndex: segmentIndex, onFinish: handleOnFinish, autoFocusInput: autoFocusInput, largeInputFontSize: true, carouselSelected: multiSelectVariant === 2, overlayInputRef: inputRef, canShowFlyAnywhere: canShowFlyAnywhere, hidePlaceholder: isA11y2904 }))));
};
export default LocationsModal;
